import { workersInfo, editWorkersInfo } from './request';
import information from './staffForm/information.vue';
import certificate from './staffForm/certificate.vue';
import { structureDetail } from './../companyCustomerManage/request';
export default {
  components: {
    information,
    certificate
  },
  data() {
    return {
      current: -1,
      stepStyle: {
        // marginBottom: '60px',
        // boxShadow: '0px -1px 0 0 #e8e8e8 inset',
        padding: '0 10%'
      },
      id: this.$route.params.id,
      infoObj: {}
    };
  },
  created() {
    this.getInfoFun();
  },
  methods: {
    nextFun(val) {
      if (val) {
        this.id = val.companyWorkerId;
        this.getInfoFun();
      }
      this.current = this.current + 1;
    },
    getInfoFun() {
      if (this.id != -1) {
        // 编辑
        // 判断是查看还是编辑
        if (this.$route.params.type == 1) {
          // 查看-客户
          workersInfo({
            companyWorkerId: this.id
          }).then(res => {
            console.log(res, 55);
            this.infoObj = res;
            if (this.current == -1) {
              this.current = 0;
            }
            this.structureDetailFun();
          });
        } else {
          // 编辑-客户
          editWorkersInfo({
            companyWorkerId: this.id
          }).then(res => {
            console.log(res, 55);
            this.infoObj = res;
            if (this.current == -1) {
              this.current = 0;
            }
            this.structureDetailFun();
          });
        }
      } else {
        this.current = 0;
        this.structureDetailFun();
      }
    },
    prevFun() {
      this.current = this.current - 1;
    },
    structureDetailFun() {
      structureDetail({
        structureId: this.$route.params.structure
      }).then(res => {
        console.log(res);
        this.infoObj.structureName = res.name;
        this.infoObj.structureId = this.$route.params.structure;
      });
    }
  }
};